module.exports = "/_next/static/images/73847fdbe67a26f4b8a54823585045db-doc-success.svg";